// Signup
export const SIGN_UP_CREATE_USER = 'SIGN_UP_CREATE_USER';
export const SIGN_UP_CREATE_ACCOUNT = 'SIGN_UP_CREATE_ACCOUNT';
export const SIGN_UP_CREATE_INTEGRATION = 'SIGN_UP_CREATE_INTEGRATION';
export const SIGN_UP_CHANGE_STEP = 'SIGN_UP_CHANGE_STEP';
export const SIGN_UP_SKIP_INTEGRATION = 'SIGN_UP_SKIP_INTEGRATION';
